import { cn } from 'lib/utils'
import { FilterXIcon } from 'lucide-react'
import { Button } from 'primitives/button'
import { memo } from 'react'
import type { DataTableFilterActions } from '../core/types'
import { type Locale, t } from '../lib/i18n'

interface FilterActionsProps {
  hasFilters: boolean
  actions?: DataTableFilterActions
  locale?: Locale
}

export const FilterActions = memo(__FilterActions)
function __FilterActions({ hasFilters, actions, locale = 'en' }: FilterActionsProps) {
  return (
    <Button
      className={cn('flex shrink-0 gap-1 py-0', !hasFilters && 'hidden')}
      variant="ghostDestructive"
      size="sm"
      aria-label={t('clear', locale)}
      data-testid="button-clear-table-filters"
      onClick={actions?.removeAllFilters}
    >
      <FilterXIcon className="size-4" />
      <span className="hidden md:block">{t('clear', locale)}</span>
    </Button>
  )
}
